import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environmentConfig } from '../../environment';
import { Observable, throwError, catchError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ToolsService {
  private apiUrl = environmentConfig.apiBaseUrl;
  constructor(private http: HttpClient) {}
  private fetchAuthenticated(
      url: string,
      method: 'GET' | 'POST' | 'PUT',
      token: string,
      bodyData?: any
    ): Observable<any> {
      const headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      });
      const httpOptions = { headers };
      let httpCall: Observable<any>;
      if (method === 'GET') {
        httpCall = this.http.get(url, httpOptions);
      } else if (method === 'POST') {
        httpCall = this.http.post(url, bodyData, httpOptions);
      } else if (method === 'PUT') {
        httpCall = this.http.put(url, bodyData, httpOptions);
      } else {
        return throwError(() => new Error('Unsupported method'));
      }
      return httpCall.pipe(
        catchError(error => {
          console.error('❌ HTTP Error:', error);
          return throwError(() => error);
        })
      );
    }


  createLinkToken(token: string): Promise<any> {
    const url = `${this.apiUrl}/api/plaid/create-link-token`;
    return this.fetchAuthenticated(url, 'POST', token).toPromise();
  }

  exchangePublicToken(publicToken: string, token: string): Promise<any> {
    const url = `${this.apiUrl}/api/plaid/exchange-public-token/${publicToken}`;
    return this.fetchAuthenticated(url, 'POST', token).toPromise();
  }

  runTaxLots(entity: string, token: string): Promise<any> {
    const url = `${this.apiUrl}/taxlots/run?entity=${encodeURIComponent(entity)}`;
    return this.fetchAuthenticated(url, 'POST', token).toPromise();
  }
  manageUsers(mode: string, obj: object, token: string): Promise<any> {
    const url = `${this.apiUrl}/api/users/manage?mode=${encodeURIComponent(mode)}`;
    return this.fetchAuthenticated(url, 'POST', token, obj).toPromise();
  }

  
}

